const encodePayload = (value) => btoa(encodeURIComponent(JSON.stringify(value)));

const decodePayload = (encoded) => JSON.parse(decodeURIComponent(atob(encoded)));

export const getStoredTokens = () => {
    const encoded = localStorage.getItem('user')
    if (!encoded) return null;
    try {
        return decodePayload(encoded)
    } catch (error) {
        try {
            return JSON.parse(atob(encoded))
        } catch (fallbackError) {
            return null
        }
    }
}

export const storeTokens = (tokens) => {
    return localStorage.setItem('user', encodePayload(tokens))
}

export const replaceTokens = (tokens) => {
    const currentUser = getStoredTokens()
    if (!currentUser) return;
    currentUser.tokens = tokens
    localStorage.setItem('user', encodePayload(currentUser))
}

export const clearTokens = () => {
    localStorage.removeItem('user')
}

export const isTokenExpired = (expires) => {
    if (!expires) return true;
    return new Date(expires).getTime() - Date.now() <= 240000;
}
